// extracted by mini-css-extract-plugin
module.exports = {"container":"reviews_container__hee3J"};